
<template>

  <div style="width: 100%; height: 100%; position:fixed; top: 0; left: 0; z-index: 7; background: rgba(0,0,0,0.4);">
    <div style="position:absolute; width: 80%; height: 80%; background: white; border-radius: 10px; top: 50%; left: 50%; transform: translate(-50%, -50%);" @click.stop="dummy">

      <template v-if="report !== false">
      <div style="width: 100%; height: 100px;">
        <div v-if="report !== false" style="height: 50px; font-size: 30px; font-weight: bold;">
          <span v-if="report.parentOder !== null">Order #{{report.parentOrder.id}} Delivery Date: {{report.deliveryDate}} </span>
        </div>
        <div v-if="report.order !== null" style="height: 50px; font-size: 30px; font-weight: bold;">
          {{report.order.title}}. Quantity: {{report.order.amount}}
        </div>
      </div>
      <div style="width: 100%; height: calc(100% - 150px); overflow-y: scroll;">

        <div class="container">
          <div class="row">
            <div class="col-12">

              <div v-for="stock in report.stocks" style="width: 100%; display: inline-block;">
                <div v-for="inventory in stock.inventories" :key="'inventory-card-item-' + inventory.id"  class="inventory-item">
                  <div class="title">
                    Inventory <br/>#{{inventory.id}}
                  </div>
                  <div class="location">
                    Location<br/>
                    {{inventory.area}} - {{inventory.location}} - {{inventory.section}}
                  </div>
                  <div class="time" v-if="inventory.sourceId === 0">
                    <b>Stocked In</b><br/> {{getTimeString(inventory.stockInTime)}}
                  </div>
                  <div class="time" v-else-if="inventory.souceId > 0">
                    Moved at {{getTimeString(inventory.createdTime)}}
                  </div>
                </div>
                <div class="stock-out-card">

                  <div class="pre-quantity"><span><i class="fas fa-arrow-right"></i></span></div>
                  <div class="quantity-container">
                    <div class="quantity">{{stock.stock.diff}}</div>
                    <div style="font-size: 15px;">
                      Stocked Out<br/>
                      {{getTimeString(stock.stock.createdTimestamp)}}
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
      <div style="width: 100%; height: 50px; text-align: right; padding-right: 50px; line-height: 50px;">
        <button class="btn btn-dark" @click="closeView">Close</button>
      </div>
      </template>
    </div>

  </div>
</template>
<script>
import {getOrderItemTracking} from "../../api/order";
import {millisToReadable, showDialog} from "../../api/utils";

export default{
  name: 'OrderTrackingView',
  props: {
    item: {
      type: Object,
      default: function(){return null;},
    },
    onClose: {
      type: Function,
      default: null,
    }
  },
  data() {
    return {
      report:false,
    }
  },
  created() {
  },
  mounted() {
    this.loadItem();
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  methods: {
    getTimeString:millisToReadable,
    dummy: function() {

    },
    loadItem: function(){

      let self = this;
      getOrderItemTracking(this.item.id)
        .then(function(data) {
          if(data.success === true) {
            self.$data.report = data.item;
          } else {
            showDialog(data.message);
          }
        })
        .catch(function(err) {
          let msg = err;
          if(err.response !== undefined) {
            msg += ' (' + err.response + ')';
          }
          showDialog(msg, "ERROR");
        })
    },
    closeView: function() {
      if(this.onClose !== null) {
        this.onClose();
      }
    }
  }
}

</script>

<style scoped>
.inventory-item {
  padding: 10px;
  border-radius: 10px;
  border: 1px solid #dadada;
  text-align: center;
  float: left;
  margin: 10px;
  box-shadow: 5px 5px 20px rgba(0,0,0,0.4);
}

.inventory-item .title {
  font-size: 20px;
  font-weight: bold;

}
.inventory-item .location{
  font-size: 18px;
  font-weight: bold;
}
.stock-out-card {
  float: left;
  margin: 10px;
  font-size : 30px;
  font-weight: bold;
  width: 200px;
  display: flex;

}
.stock-out-card .quantity {
  width: 100px;
  height: 100px;
  line-height: 100px;
  border-radius: 50px;
  background: #2fac66;
  color: white;
  font-weight: bold;
  font-size: 50px;
}
.stock-out-card .quantity-container {
  width: 100px;

}
.stock-out-card .pre-quantity {
  width: 100px;
  height: 100px;
  line-height: 100px;
  border-radius: 50px;
  background: #fff;
  color: black;
  font-weight: bold;
  font-size: 50px;
}
</style>



// WEBPACK FOOTER //
// src/components/ItemView/OrderItemTrackingView.vue